import { FormGroup, Input, Select } from '../../components/Form';
import { formatFloatToCurrency } from '../../lib/formatting';

export const ParcelamentoSection = ({ formData, onChange, valorTotal, isSubmitting, submitLabel }) => (
    <div className="card">
        <p className="section-label">Parcelamento</p>
        <div className="grid-3">
            <FormGroup label="Valor a Parcelar (R$)" htmlFor="valorParcelar">
                <Input id="valorParcelar" name="valorParcelar" value={formData.valorParcelar} onChange={onChange} placeholder="0,00" />
            </FormGroup>
            <FormGroup label="Qtd. de Parcelas" htmlFor="parcelas">
                <Select id="parcelas" name="parcelas" value={formData.parcelas} onChange={onChange}>
                    <option value="">Selecione</option>
                    {[...Array(12)].map((_, i) => <option key={i + 1} value={i + 1}>{i + 1}x</option>)}
                </Select>
            </FormGroup>
            <FormGroup label="Forma do Parcelamento" htmlFor="formaPagamentoParcelas">
                <Select id="formaPagamentoParcelas" name="formaPagamentoParcelas" value={formData.formaPagamentoParcelas} onChange={onChange}>
                    <option value="">Selecione</option>
                    <option value="Cartão de Crédito">Cartão de Crédito</option>
                    <option value="Boleto">Boleto</option>
                </Select>
            </FormGroup>
        </div>

        <div style={{
            marginTop: '1.25rem',
            padding: '1rem 1.25rem',
            background: 'var(--canvas)',
            border: '1px solid var(--glass-border)',
            borderTop: '1px solid rgba(240, 245, 242, 0.16)',
            borderRadius: '10px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        }}>
            <span style={{ color: 'var(--muted)', fontSize: '0.875rem', fontWeight: 500 }}>Valor total da venda</span>
            <span style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--ink)', fontVariantNumeric: 'tabular-nums' }}>
                R$ {formatFloatToCurrency(valorTotal)}
            </span>
        </div>

        <div className="form-footer">
            <button type="submit" className="pill pill-primary" disabled={isSubmitting}>
                {isSubmitting ? 'Registrando...' : submitLabel}
            </button>
        </div>
    </div>
);
